// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c0edf3a3f3ebf586","5285":"e653f240cd12ba1d"}[chunkId] + ".css";
};